// extracted by mini-css-extract-plugin
export var component = "TableModule-module--component--dQwq8";
export var head = "TableModule-module--head--wjClQ";
export var table = "TableModule-module--table--E6JWF";
export var td = "TableModule-module--td--8yS07";
export var th = "TableModule-module--th--3gXjO";
export var title = "TableModule-module--title--DPYDw";